import { pgTable, uuid, text, timestamp, boolean, jsonb, pgEnum } from "drizzle-orm/pg-core";
import { sites } from "./sites";

// F6: CV検知方式のStrategy切替（ga4_event優先→selectorフォールバック→url→custom）
export const goalSourceEnum = pgEnum("goal_source", ["ga4_event", "selector", "url", "custom"]);
export const goalDedupEnum = pgEnum("goal_dedup", ["session", "always"]);

export const goals = pgTable("goals", {
  id: uuid("id").primaryKey().defaultRandom(),
  siteId: uuid("site_id").notNull().references(() => sites.id, { onDelete: "cascade" }),
  name: text("name").notNull(),
  source: goalSourceEnum("source").notNull(),
  // source別: {ga4EventName} / {selector, event:'click'} / {url, matchType} / {} (custom)
  config: jsonb("config").notNull(),
  isMicro: boolean("is_micro").notNull().default(false),
  dedup: goalDedupEnum("dedup").notNull().default("session"),
  createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
});
